import { Helpers, Utils } from '../../Core';
import { getCmsDeliveryApi as API } from '../../Apis';
import { mocksService } from './GetCmsClubSmilesTerms.mocks';
import dataFields from '../../Types/CmsCobrandedCard.json';
import { ClubSmilesTermsRaw } from '../../Types/CmsClubSmilesTerms.types';

const prepareCall = async () => {
  const { cmsDeliveryIds } = Helpers.getConstants();
  const { CLUB_SMILES_TERMS } = cmsDeliveryIds as {
    [key: string]: string;
  };

  return API.call.get({
    contentId: CLUB_SMILES_TERMS,
  });
};

const handleSucessFinalResponseFunction = (
  result: ClubSmilesTermsRaw,
): { id: string; content: string } => {
  const { content, id } = result;
  return { id, content: content.Content };
};

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction: prepareCall,
  definitionsAPI: API.definitions,
  handleResponse: { handleSucessFinalResponseFunction },
  mocksService,
  dataFields,
});
